module.exports = __webpack_public_path__ + "img/15.eeab2746.png";